import { render, staticRenderFns } from "./ReferenceDocumentDialog.vue?vue&type=template&id=27a826fe&scoped=true&"
import script from "./ReferenceDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./ReferenceDocumentDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceDocumentDialog.vue?vue&type=style&index=0&id=27a826fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a826fe",
  null
  
)

export default component.exports